// frontend/src/components/FilterContainer.js
import React from 'react';
import { getOwnershipOptions } from '../utils/statusOptions';

const FilterContainer = ({ mediaType, statusOptions, filters, onFilterChange, visibleItems, canViewExplicit  }) => {
  const ownershipOptions = getOwnershipOptions(mediaType);
  const animeMediaTypes = ['tv', 'movie', 'ova', 'special', 'unknown'];
  const screenMediaTypes =['animation','live-action']
  const seasonOptions = ['Single Season', 'Multiple Seasons'];
  const conditionOptions = ['Excellent', 'Good', 'Okay', 'Bad', 'Poor'];

  const countItems = (field, value) => {
    if (field === 'seasons') {
      return visibleItems.filter(item => {
        const hasMultiple = item.seasons?.length > 1;
        return value === 'Multiple Seasons' ? hasMultiple : !hasMultiple;
      }).length;
    }

    if (field === 'explicit') {
      return visibleItems.filter(item => String(item.explicit ?? false) === String(value)).length;
    }

    return visibleItems.filter(item => item[field] === value).length;
  };

  const handleCheckboxChange = (type, value) => {
    const checked = !(filters[type]?.includes(value));
    onFilterChange(type, value, checked);
  };

  return (
    <div className="filter-container">
      {statusOptions.length > 0 && (
        <>
          <div className="filter-group">
            <h3>Status</h3>
            {statusOptions.map(status => (
              <label key={status} className="filter-label">
                <input
                  type="checkbox"
                  checked={filters.status?.includes(status) || false}
                  onChange={() => handleCheckboxChange('status', status)}
                />
                {status} ({countItems('status', status)})
              </label>
            ))}
          </div>
          <hr className="filter-divider" />
        </>
      )}

      {['Anime', 'AnimeSerie', 'TV', 'Movie', 'ScreenMedia'].includes(mediaType) && (
        <>
          <div className="filter-group">
            <h3>Media Type</h3>
            {['Anime', 'AnimeSerie'].includes(mediaType) && animeMediaTypes.map(type => (
              <label key={type} className="filter-label">
                <input
                  type="checkbox"
                  checked={filters.media_type?.includes(type) || false}
                  onChange={() => handleCheckboxChange('media_type', type)}
                />
                {type.charAt(0).toUpperCase() + type.slice(1)} ({countItems('media_type', type)})
              </label>
            ))}
            {['TV', 'Movie', 'ScreenMedia'].includes(mediaType) && screenMediaTypes.map(type => {
              const isAnimated = type === 'animation';
              return (
                <label key={type} className="filter-label">
                  <input
                    type="checkbox"
                    checked={filters.is_animated?.includes(String(isAnimated)) || false}
                    onChange={() => handleCheckboxChange('is_animated', String(isAnimated))}
                  />
                  {type.charAt(0).toUpperCase() + type.slice(1)} ({countItems('is_animated', isAnimated)})
                </label>
              );
            })}
          </div>
          <hr className="filter-divider" />
          {['Anime', 'AnimeSerie', 'TV', 'ScreenMedia'].includes(mediaType) && 
          <>
            <div className="filter-group">
              <h3>Seasons</h3>
              {seasonOptions.map(option => (
                <label key={option} className="filter-label">
                  <input
                    type="checkbox"
                    checked={filters.seasons?.includes(option) || false}
                    onChange={() => handleCheckboxChange('seasons', option)}
                  />
                  {option} ({countItems('seasons', option)})
                </label>
              ))}
            </div>
            <hr className="filter-divider" />
          </>
          }
        </>
      )}

      {ownershipOptions.length > 0 && (
        <>
          <div className="filter-group">
            <h3>Ownership</h3>
            {ownershipOptions.map(ownership => (
              <label key={ownership} className="filter-label">
                <input
                  type="checkbox"
                  checked={filters.ownership_status?.includes(ownership) || false}
                  onChange={() => handleCheckboxChange('ownership_status', ownership)}
                />
                {ownership} ({countItems('ownership_status', ownership)})
              </label>
            ))}
          </div>
          <hr className="filter-divider" />
        </>
      )}

      {['Manga', 'PhysicalGame', 'PSPGame', 'NDSGame', 'GameboyGame', 'SwitchGame', 'PS3Game', 'VitaGame', 'Music', 'Vinyl', 'CD'].includes(mediaType) && (
        <>
          <div className="filter-group">
            <h3>Condition</h3>
            {conditionOptions.map(condition => (
              <label key={condition} className="filter-label">
                <input
                  type="checkbox"
                  checked={filters.condition?.includes(condition) || false}
                  onChange={() => handleCheckboxChange('condition', condition)}
                />
                {condition} ({countItems('condition', condition)})
              </label>
            ))}
          </div>
          <hr className="filter-divider" />
        </>
      )}

      {mediaType === 'SteamGame' && (
        <div className="filter-group">
          <h3>Achievements</h3>
          <label className=" ../../filter-label">
            <input
              type="checkbox"
              checked={filters.achievements?.includes('has-achievements') || false}
              onChange={() => handleCheckboxChange('achievements', 'has-achievements')}
            />
            Has Achievements ({visibleItems.filter(item => item.total_achievements > 0).length})
          </label>
        </div>
      )}

      {canViewExplicit && (
        <>
          <div className="filter-group">
            <h3>Explicit</h3>
            {['Safe', '18+'].map(option => {
              const value = option === '18+';
              return (
                <label key={option} className="filter-label">
                  <input
                    type="checkbox"
                    checked={filters.explicit?.includes(String(value)) || false}
                    onChange={() => handleCheckboxChange('explicit', String(value))}
                  />
                  {option} ({countItems('explicit', value)})
                </label>
              );
            })}
          </div>
          <hr className="filter-divider" />
        </>
      )}

    </div>
  );
};

export default FilterContainer;